import {
  createFrontendModule,
  configApiRef,
  useApi,
  AppRootElementBlueprint,
} from '@backstage/frontend-plugin-api';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

let appInsights: ApplicationInsights | undefined;

function getApplicationInsights(connectionString: string) {
  if (!appInsights) {
    appInsights = new ApplicationInsights({
      config: {
        connectionString,
        enableAutoRouteTracking: false,
        disableAjaxTracking: true,
        disableFetchTracking: true,
      },
    });

    appInsights.loadAppInsights();
  }

  return appInsights;
}

function ApplicationInsightsPageViewTracker() {
  const configApi = useApi(configApiRef);
  const location = useLocation();

  const connectionString = configApi.getOptionalString(
    'app.analytics.applicationInsights.connectionString',
  );

  useEffect(() => {
    if (!connectionString) {
      return;
    }

    getApplicationInsights(connectionString).trackPageView({
      uri: window.location.href,
      name: document.title,
    });
  }, [connectionString, location.pathname, location.search, location.hash]);

  return null;
}

const applicationInsightsPageViewTracker = AppRootElementBlueprint.make({
  name: 'application-insights-page-view-tracker',
  params: {
    element: <ApplicationInsightsPageViewTracker />,
  },
});

export const applicationInsightsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [applicationInsightsPageViewTracker],
});
